import React from 'react';
import { Button, Modal, ModalBody, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { SUCCESS, ERROR } from 'app/config/constants';
import { colors } from 'app/config/color';
export interface IMessageModalProps {
  showModal: boolean;
  message: string;
  type: string;
}

class MessageModal extends React.Component<IMessageModalProps> {
  constructor(props) {
    super(props);
  }

  renderIcon = type => {
    switch (type) {
      case SUCCESS:
        return <FontAwesomeIcon icon={faCheckCircle} size="3x" color={colors.colorSuccess} />;
      case ERROR:
        return <FontAwesomeIcon icon={faExclamationTriangle} size="3x" color={colors.colorWarning} />;
      default:
        return <FontAwesomeIcon icon={faInfoCircle} size="3x" color={colors.colorInfo} />;
    }
  };

  render() {
    return (
      <div>
        <Modal id="modalMessage" isOpen={this.props.showModal} backdrop="static" centered={window.location === window.parent.location}>
          <ModalBody>
            <Row className="justify-content-center">
              <Col md={8}>
                <p className="text-center">{this.renderIcon(this.props.type)}</p>
                <h5 className="text-center font-weight-bold titleMsg">{this.props.message}</h5>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default MessageModal;
